import { ChangeDetectorRef, Component, EventEmitter, Input, Output } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { SharedService } from 'app/shared/services/shared.service';
import { EventBusService } from 'framework/eventbus.service';
import { BehaviorSubject, of } from 'rxjs';
import { catchError, distinctUntilChanged, filter, switchMap, tap } from 'rxjs/operators';
import * as dateUtils from 'framework/utils/date.utils';
import { EmploymentService } from 'app/employment/employment.service';
import { TranslateService } from 'framework/i18n/translate.service';
import { EmploymentConfig } from 'app/employment/employment.config';
import { Store } from '@ngrx/store';
import * as ACTIONS_INTERFACE from '../../../actions';

@Component({
  selector: 'additional-education-details',
  templateUrl: './additional-education-details.component.html',
  styleUrls: ['./additional-education-details.component.css']
})
export class AdditionalEducationDetailsComponent {
  static STAGE_ID: string;
  static STEP_ID: string = 'additional-education-step-v1';
  static STEP_INDEX: number = 0;
  public SUB_STEP_ID: string;
  public SUB_STEP_INDEX: number;
  PARENT_STAGE_STEP_CONFIG: Object;
  
  jobFromId;
  jobToId;
  fromDefaultDate: Date;
  fromSetDate: Date;
  fromMinDate: Date
  fromMaxDate: Date;
  toDefaultDate: Date;
  toSetDate: Date;
  toMinDate: Date;
  toMaxDate: Date;
  isAdditionalEducationError: boolean = false;
  showStartDateRangeErrorMsg: boolean = false;
  showEndDateRangeErrorMsg: boolean = false;
  invalidDate: boolean = false;
  
  countryId: string;
  countryList: any = [];
  selectedCountry: string;
  isCountryValid: boolean;
  errorMsgShow: boolean;
  isCountryError: boolean;
  latestCountryLnamFromApi: any;
  countryOptions: Object;
  countryShortName: any;
  validCountryFlag: boolean;
      
  stateCode: string;
  stateShortName: string;
  zipCodeList: any[];
  stateList: any[];
  cityList: any[];
  isCountryChanged: boolean;
  fromDateOptions: any;
  toDateOptions: any;
  monthNames = this._ts.instant('MONTH_NAMES');
  
  isOpenGoogleSuggestion: boolean;
  cityStateId: string;
  cityId: string;
  stateId: string;
  zipId: string;
  cityStateErrFlag: boolean;
  showCitySateErr: boolean;
  getGeoOption: Object;
  cityOptions: any;
  optionsStateCode: any;
  isViewInit: any;
  
  selectedState: any;
  selectedCity: string;
  selectedZipCode: string;
  
  isJobToValid: boolean;
  payLoad: { name: any; step: any; stepIndex: any; subStep: string; subStepIndex: number; iteration: any; status: any; dbRecordPresent: any; };
  currentStatus: string = 'VISITED';
  isJobPeriodError: boolean = false;
  isStartDateIsFutureDate: boolean = false;
  isEndDateIsFutureDate: boolean = false;
  cityCode: string = '';
  validStateFlag: boolean = false;
  validCityFlag: boolean = false;
  isStateListToShow: boolean = false;
  isCityListToShow: boolean = false;
  isZipListToShow: boolean = false;
  showCityErr: boolean = false;
  showStateErr: boolean = false;
  startTime: any;
  
  @Input('group')
  public additionalEducationSubForm: FormGroup;
  @Input() row: any;
  @Input() isEmploymentGapInDaysEnabled: boolean;
  @Input() options: any;
  @Input() isReviewEdit: boolean;
  @Input() isReview: boolean;
  @Input() isReviewAdd: boolean;
  @Input() configOptions: any;

  
  @Input()
  set dateOptions(value) {
    this._data.next(value);
  };

  get dateOptions() {
    return this._data.getValue();
  }
  _data = new BehaviorSubject<any>([]);
  
  countryTypeahead = new EventEmitter<string>();
  stateTypeahead = new EventEmitter<string>();
  cityTypeahead = new EventEmitter<string>();
  zipCodeTypeahead = new EventEmitter<string>();
  
  private _zipCodeError = new BehaviorSubject<any>([]);
  @Input()
  set zipCodeError(value) {
    this._zipCodeError.next(value);
  }
  get zipCodeError() {
    return this._zipCodeError.getValue();
  }

  @Output() onSaveExit = new EventEmitter<any>();
  @Output() onAdditionalEducationDetails = new EventEmitter<any>();
  @Output() onAdditionalEducationDetailsSwipe = new EventEmitter<any>();
  @Output() onMakeServerValidator = new EventEmitter<any>();
  
  constructor(private _eventBus: EventBusService,
              private _cdr: ChangeDetectorRef,
              private _sharedService: SharedService,
              private _es: EmploymentService,
              private _ts: TranslateService,
              private _store: Store<ACTIONS_INTERFACE.AppState>) {
    this.startTime = new Date().getTime();
  }

  ngOnInit() {
    this._data
      .subscribe(x => {
        if (x !== undefined) {
          this.setDate();
        }
      });
      
    this.countryId = 'empAdditionalEducationCountry_' + this.row;
    this.isCountryValid = true;
    this.zipCodeList = [];
    this.isZipListToShow = false;
    this.isOpenGoogleSuggestion = false;
    
    this.cityStateId = 'empAdditionalEducationCityState_' + this.row;
    this.cityId = 'empAdditionalEducationCity_' + this.row;
    this.stateId = 'empAdditionalEducationState_' + this.row;
    this.zipId = 'empAdditionalEducationZipCode_' + this.row;
    this.cityStateErrFlag = false;
    this.showCitySateErr = false;

    this.jobFromId = `empAdditionalEducationJobFrom_${this.row}`;
    this.jobToId = `empAdditionalEducationJobTo_${this.row}`;
    
    this.getGeoOption = this._es.getGeoOptions();
    this.cityOptions = this.getGeoOption['city'];
    this.toDateOptions = this.getGeoOption['state'];
    
    // if (this.activeGapOption) {
    // this.setDate();
    // }
  }
  
  ngOnChanges() {
    if (this.isViewInit) {
      this.setDate();
    }
    
    let defaultCountryOptions = EmploymentConfig.defaultCountryOptions();
    this.countryOptions = this.options['countryOptions'];
    this.optionsStateCode = this.options['stateOptions'];
    
    if (this.row === 0) {
      this.countryShortName = defaultCountryOptions['defaultCountryShortName'];
      this.isCountryValid = true;

      let countryName = <FormControl>this.additionalEducationSubForm.controls['countryName'].value || '';
      let countryCode = <FormControl>this.additionalEducationSubForm.controls['countryCode'].value || '';

      if (!!countryCode) {
        this.countryShortName = countryCode || defaultCountryOptions['defaultCountryShortName'];
      }

      if (!this.isReviewEdit) {
        this.selectedCountry = countryName || defaultCountryOptions['defaultCountry'];

        (<FormControl>this.additionalEducationSubForm.controls['countryName']).setValue(countryName || defaultCountryOptions['defaultCountry']);
        (<FormControl>this.additionalEducationSubForm.controls['countryCode']).setValue(countryCode || this.countryShortName);
      }
    }
    
    if (this.countryOptions['country'] !== null && this.countryOptions['country'] !== undefined && this.countryOptions['country'] !== '') {
      this.countryShortName = this.countryOptions['countryShortName'];
    
      this.selectedCountry = this.countryOptions['country'];
      (<FormControl>this.additionalEducationSubForm.controls['countryName']).setValue(this.countryOptions['country']);
      (<FormControl>this.additionalEducationSubForm.controls['countryCode']).setValue(this.countryOptions['countryShortName']);
    } else {
      let countryName = <FormControl>this.additionalEducationSubForm.controls['countryName'].value || '';
      let countryCode = <FormControl>this.additionalEducationSubForm.controls['countryCode'].value || '';
      
      if (!!countryCode || !!countryName) {
        defaultCountryOptions['defaultCountryShortName'] = countryCode;
        defaultCountryOptions['defaultCountry'] = countryName;
      }
      this.countryShortName = defaultCountryOptions['defaultCountryShortName'];

      this.selectedCountry = defaultCountryOptions['defaultCountry'];
      (<FormControl>this.additionalEducationSubForm.controls['countryName']).setValue(defaultCountryOptions['defaultCountry']);
      (<FormControl>this.additionalEducationSubForm.controls['countryCode']).setValue(defaultCountryOptions['defaultCountryShortName']);
    }
    
    this.latestCountryLnamFromApi = (<FormControl>this.additionalEducationSubForm.controls['countryName']).value;

    if (this.optionsStateCode !== undefined && this.optionsStateCode['stateCode'] !== undefined) {
      this.stateCode = this.optionsStateCode['stateCode'];
    }
    
    this.validateCountry(this.additionalEducationSubForm.controls['countryName'].value, 'onInit');
    this.validateCity(this.additionalEducationSubForm.controls['city'].value);
    this.validateState(this.additionalEducationSubForm.controls['stateName'].value);
    
    this.selectedCountry = this.additionalEducationSubForm.controls['countryName'].value;
    this.selectedState = this.additionalEducationSubForm.controls['stateName'].value;
    this.selectedCity = this.additionalEducationSubForm.controls['city'].value;
    this.selectedZipCode = this.additionalEducationSubForm.controls['zipCode'].value;

    this.countryServerSideSearch();
    this.stateServerSideSearch();
    this.cityServerSideSearch();
    this.zipCodeServerSideSearch();
  }
  
  ngAfterViewInit() {
    this.processConfig();

    if (this.additionalEducationSubForm.controls['jobTo'] !== undefined && this.additionalEducationSubForm.controls['jobTo'].value !== '') {
      this.isJobToValid = true;
    }
    
    this.isViewInit = true;
    this._cdr.detectChanges();
  }
  
  private processConfig(): void {
    this.PARENT_STAGE_STEP_CONFIG = this.configOptions['PARENT_CONFIG'];
    this.SUB_STEP_ID = EmploymentConfig.additionalEducationSubStepIndexMapping['details']['subStep'];
    this.SUB_STEP_INDEX = EmploymentConfig.additionalEducationSubStepIndexMapping['details']['subStepIndex'];

    this.setState();
  }
  
  private setState(): void {
    this.payLoad = {
      name: this.PARENT_STAGE_STEP_CONFIG['STAGE_ID'],
      step: AdditionalEducationDetailsComponent.STEP_ID,
      stepIndex: AdditionalEducationDetailsComponent.STEP_INDEX,
      subStep: this.SUB_STEP_ID,
      subStepIndex: this.SUB_STEP_INDEX,
      iteration: this.row,
      status: this.currentStatus,
      dbRecordPresent: this.PARENT_STAGE_STEP_CONFIG['IS_DB_RECORD_PRESENT']
    };

    this._store.dispatch({ type: this.currentStatus, payload: this.payLoad });
  }
  
  doSwipe(direction: string, data) {
    if (direction === 'swiperight') {
      this.getPrevSwipe(data);
    }
    if (direction === 'swipeleft') {
      this.additionalEducationDetails(data);
    }
  }
  
  getPrevSwipe(obj) {
    let indexDetail: Object = {};
    indexDetail['row'] = this.row;
    obj['indexDetail'] = indexDetail;
    
    this.onAdditionalEducationDetailsSwipe.emit(obj);
  }
  
  additionalEducationDetails(obj): void {
    if (this.currentStatus === 'VISITED') {
      this.currentStatus = 'COMPLETED';
    }
    
    if (this.additionalEducationSubForm.controls['jobFrom'] !== undefined && this.additionalEducationSubForm.controls['jobTo'] !== undefined) {
      let jobFrom = this.getDateEngValue((<FormControl>this.additionalEducationSubForm.controls['jobFrom']).value);
      let jobTo = this.getDateEngValue((<FormControl>this.additionalEducationSubForm.controls['jobTo']).value);
      
      obj['jobFrom'] = jobFrom;
      obj['jobTo'] = jobTo;
      
      this.validateDate(jobFrom, jobTo);
      
      if (this.isStartDateIsFutureDate) {
        this.showStartDateRangeErrorMsg = true;
      }
      if (this.isEndDateIsFutureDate) {
        this.showEndDateRangeErrorMsg = true;
      }
    }
    
    obj['type'] = 'inSchool';
    obj['is_collect_education'] = true;
    
    this.setState();
    
    let indexDetail: Object = {};
    indexDetail['row'] = this.row;
    obj['indexDetail'] = indexDetail;
    obj['COMPONENT_STATE'] = this.payLoad;
    obj['startTime'] = this.startTime;
    
     if (!this.isStartDateIsFutureDate && !this.isEndDateIsFutureDate) {
      this.onAdditionalEducationDetails.emit(obj);
    }
    
    this.invalidDate = false;
  }
  
  /* Address Details - Country methods - Start */
    
  trackCountryChange(value) {
    let selectedData = !!value ? value : '';
    let selectedCountry = (<FormControl>this.additionalEducationSubForm.controls['countryCode']).value;
    
    if (selectedCountry !== selectedData['country_code']) {
      this.isCountryChanged = true;
    } else {
      this.isCountryChanged = false;
    }
    
    if (this.isCountryChanged) {
      this.onClearZipCodeData();
      this.onClearStateData();
      this.onClearCityData();
    }
    
    this.validateCountry(selectedData['country_name']);
    this.setFieldValues(selectedData);
  }
  
  private countryServerSideSearch() {
    this.countryTypeahead.pipe(
      distinctUntilChanged(),
      filter(term => {  return (term !== undefined && term !== null) }),
      switchMap(term => this._sharedService.countryCodeLookupSwitch({ countryParam: term })
      .pipe(
        catchError(() => of({ 'country_list': [] }))
        )
      )
    ).subscribe(countryData => {
      this.countryList =  countryData['country_list'];
      if (this.countryList.length > 0) {
          this.isCountryError = true;
          this.errorMsgShow = false;
      } else {
        let countryName = this.additionalEducationSubForm.controls['countryName'].value;
        if (countryName === '') {
          this.isCountryError = false;
          this.errorMsgShow = true;
        }
      }
    }, (err) => {
        console.log(err);
        this.countryList = [];
    });
  }
  
  countryLookUp() {
    let countryNameValue = (<FormControl>this.additionalEducationSubForm.controls['countryName']).value;
    
    if(countryNameValue === undefined || countryNameValue === ''){
      let cnty = !!(<FormControl>this.additionalEducationSubForm.controls['countryName']).value ? (<FormControl>this.additionalEducationSubForm.controls['countryName']).value: '';
      
      if(!cnty){
        this._sharedService.countryCodeLookupSwitch({countryParam: cnty}).subscribe(countryData => {
        this.countryList =  countryData['country_list'];
        
        if (this.countryList.length > 0) {
            this.isCountryError = true;
            this.errorMsgShow = false;
        } else {
            this.isCountryError = false;
            this.errorMsgShow = true;
        }
      }, (err) => {
          console.log(err);
          this.countryList = [];
      });
      }
    }
  }
  
  validateCountry(countryValue, method?) {
    if (countryValue !== undefined && countryValue !== '' && countryValue !== null || (method === 'onInit')) {
      // this.validCountryFlag = true;
      this.errorMsgShow = false;
    } else {
      // this.validCountryFlag = false;
      this.errorMsgShow = true;
    }
  }
  
  setFieldValues(values): void {
    if (this.additionalEducationSubForm.controls['countryName']) {
      this.additionalEducationSubForm.controls['countryName'].setValue(values['country_name']);
    } 
    if (this.additionalEducationSubForm.controls['countryCode']) {
      this.additionalEducationSubForm.controls['countryCode'].setValue(values['country_code']);
    }
    
    this.latestCountryLnamFromApi = values['country_name'];
    this.countryOptions = {
      country: values['country_name'],
      countryShortName: values['country_code']
    }
    this.countryShortName = values['country_code'];
    this.selectedCountry = values['country_name'];
      
    if (values !== '') {
      this.isCountryValid = true;
      this.isCountryError = false;
    } else {
      this.isCountryValid = false;
      this.isCountryError = true;
    }
    
    this._cdr.detectChanges();
  }

  onClearData() {
    (<FormControl>this.additionalEducationSubForm.controls['countryName']).setValue('');
    (<FormControl>this.additionalEducationSubForm.controls['city']).setValue('');
    (<FormControl>this.additionalEducationSubForm.controls['stateName']).setValue('');
    (<FormControl>this.additionalEducationSubForm.controls['stateCode']).setValue('');
    (<FormControl>this.additionalEducationSubForm.controls['zipCode']).setValue('');
    
    this.stateCode = this.stateShortName = '';
    this.zipCodeList = [];
    this.stateList = [];
    this.cityList = [];
    
    this.countryLookUp();
  }
  
  closeCountryError() {
    this.isCountryError = !this.isCountryError;
    this.errorMsgShow = !this.errorMsgShow;
  }
  
  openCountryError() {
    this.isCountryError = false;
    this.errorMsgShow = true;
  }
    
  /* Address Details - Country methods - End */
  
  getFromDpValue(value): void {
    // console.log('jobFrom values ---- ' + value);
    (<FormControl>this.additionalEducationSubForm.controls['jobFrom']).setValue(value);
    let fromEngDate = this.getDateEngValue(value);// Calculcation purpose

    this._es.jobFromDateCollection[this.row] = fromEngDate;
    if (!!value) {
      this.dateOptions['from'] = this._es.fromDateOptions(fromEngDate);
    }
    
    if (this.additionalEducationSubForm.controls['jobFrom'] !== undefined && this.additionalEducationSubForm.controls['jobTo'] === undefined) {
      this.validateDate(fromEngDate);
    }
    
    if (this.additionalEducationSubForm.controls['jobFrom'] !== undefined && this.additionalEducationSubForm.controls['jobTo'] !== undefined) {
      let toEngDate = this.getDateEngValue((<FormControl>this.additionalEducationSubForm.controls['jobTo'].value));// Calculcation purpose
      this.validateDate(fromEngDate, toEngDate);
    }
  }
  
  getToDpValue(value): void {
    if (this.additionalEducationSubForm.controls['jobTo'] !== undefined) {
      this.isJobToValid = true;
      (<FormControl>this.additionalEducationSubForm.controls['jobTo']).setValue(value);
      let toEngDate = this.getDateEngValue(value);// Calculcation purpose
      let fromEngDate = this.getDateEngValue((<FormControl>this.additionalEducationSubForm.controls['jobFrom']).value);// Calculcation purpose
      this._es.jobToDateCollection[this.row] = toEngDate;
      
      if (!!toEngDate) {
        this.dateOptions['to'] = this._es.toDateOptions(toEngDate);
        this.validateDate(fromEngDate, toEngDate);
      }
    }
  }
  
  public validateDate(jobFrom: any, jobTo?: any) {
    let monthDiff;
    let formatedFromDate = '';
    let formatedToDate = '';
    let startDate;
    let endDate;
    this.showStartDateRangeErrorMsg = false;
    this.showEndDateRangeErrorMsg = false;

    if (this.additionalEducationSubForm.controls['jobFrom'] !== undefined && this.additionalEducationSubForm.controls['jobTo'] === undefined) {
      formatedFromDate = this._es.formatDate(jobFrom);
      if (jobFrom !== undefined && jobFrom !== null) {
        startDate = this._es.getDateToTs(jobFrom);
      }
      
      if (formatedFromDate !== undefined && formatedFromDate !== null) {
        this.invalidDate = false;
        this.isJobPeriodError = false;
        this.checkForFutureDate(startDate, 'START_DATE');
      } else {
        this.invalidDate = true;
        this.isJobPeriodError = true;
      }
    }

    if (this.additionalEducationSubForm.controls['jobFrom'] !== undefined && this.additionalEducationSubForm.controls['jobTo'] !== undefined) {
      formatedToDate = this._es.formatDate(jobTo);
      formatedFromDate = this._es.formatDate(jobFrom);
      
      if (this.isEmploymentGapInDaysEnabled) {
        monthDiff = dateUtils.dateDiffInDays(formatedFromDate, formatedToDate);
      } else {
        monthDiff = this._es.monthDiffOfDates(formatedFromDate, formatedToDate);
      }

      if (jobFrom !== undefined && jobFrom !== null) {
        startDate = this._es.getDateToTs(jobFrom);
        this.checkForFutureDate(startDate, 'START_DATE');
      }

      if (jobTo !== undefined && jobTo !== null) {
        endDate = this._es.getDateToTs(jobTo);
        this.checkForFutureDate(endDate, 'END_DATE');
      }
    }
    
    if (monthDiff <= 0) {
      this.invalidDate = true;
      this.isJobPeriodError = false;
    } else {
      this.invalidDate = false;
      this.isJobPeriodError = true;
    }
  }
  
  checkForFutureDate(date, dateLocation) {
    let currentDate = this.getCurrentDate();
    
    if (currentDate !== undefined) {
      let currentDateInTS = this._es.getDateToTs(currentDate);
      
      if (date !== undefined) {
        let diff: number;
        
        if (this.isEmploymentGapInDaysEnabled) {
          diff = dateUtils.dateDiffInDays(currentDateInTS, date);
        } else {
          diff = this._es.monthDiffOfDates(currentDateInTS, date);
        }
        
        if (diff > 1) {
          if (dateLocation === 'START_DATE') {
            this.isStartDateIsFutureDate = true;
            this.showStartDateRangeErrorMsg = true;
          } else if (dateLocation === 'END_DATE') {
            this.isEndDateIsFutureDate = true;
            this.showEndDateRangeErrorMsg = true;
          } 
        } 
      }
    }
  }
  
  private getCurrentDate(): any {
    let now: Date = new Date();
    let currentMonth: string = this._es.monthNames[now.getMonth()];
    let currentYear: number = now.getFullYear();
    
    if (this.isEmploymentGapInDaysEnabled) {
      return `${currentMonth} ${now.getDate()},${now.getFullYear()}`;
    } else {
      return `${currentMonth} ${now.getFullYear()}`;
    }
  }
  
  private getDateEngValue(languageDate) {
    if (this.isEmploymentGapInDaysEnabled) {
      return languageDate === '' ? languageDate : dateUtils.formatEngFullDateLabel(languageDate, this.monthNames, this._es.monthNames);
    } else {
      return languageDate === '' ? languageDate : dateUtils.formatEngDateLabel(languageDate, this.monthNames, this._es.monthNames);
    }
  }
  
  getStartDateError(obj) {
    this.isStartDateIsFutureDate = false;
    
    if (obj !== undefined && obj !== null) {
      if (obj['isInvalidDate']) {
        this.isStartDateIsFutureDate = true;
      }
    }
  }
  
  getEndDateError(obj) {
    this.isEndDateIsFutureDate = false;
    
    if (obj !== undefined && obj !== null) {
      if (obj['isInvalidDate']) {
        this.isEndDateIsFutureDate = true;
      }
    }
  }
  
  private setDate() {
    this.fromDateOptions = this.dateOptions['from'];
    this.toDateOptions = this.dateOptions['to'];
    
    this.setFromDate();
    this.setToDate();
  }
  
  private setFromDate() {
    if (this.dateOptions['from']) {
      this.fromMinDate = this.fromDateOptions['minDate'];
      this.fromMaxDate = this.fromDateOptions['maxDate'];
      this.fromDefaultDate = this.fromDateOptions['defaultDate'];
      
      if (this.additionalEducationSubForm.controls['jobFrom'] !== undefined) {
        let jobFrom = (<FormControl>this.additionalEducationSubForm.controls['jobFrom']).value;
        
        if (this.isReviewEdit || !!jobFrom) {
          if (!!jobFrom) {
            let currentLang = this._ts.instant("MONTH_NAMES");
            let engLang = this._sharedService.getEngMonths();
            let formatToEngLang: string;
            
            if (this.isEmploymentGapInDaysEnabled) {
              formatToEngLang = dateUtils.convertFullDateToEngFormat(jobFrom, currentLang, engLang);
            } else {
              formatToEngLang = dateUtils.convertToEngFormat(jobFrom, currentLang, engLang);
            }
            
            this.fromSetDate = this._es.fromDateOptions(formatToEngLang)['defaultDate'];
          } else {
            this.fromSetDate = this.fromDateOptions['defaultDate'];
          }

          let setMonthNo = new Date(this.fromSetDate).getMonth();
          let setyear = new Date(this.fromSetDate).getFullYear();
          let setMonthName = this.monthNames[setMonthNo];
          let setMonthYear = `${setMonthName} ${setyear}`;
          
          if (this.fromSetDate == undefined) {
            let setMonthYear = '';
            
            this.getFromDpValue(setMonthYear);
          } else {
            if (this.isEmploymentGapInDaysEnabled) {
              let setDay = new Date(this.fromSetDate).getDate();
              let setMonthDayYear = `${setMonthName} ${setDay},${setyear}`;
              
              this.getFromDpValue(setMonthDayYear);
            } else {
              this.getFromDpValue(setMonthYear);
            }
          }
        }
      }
    } else {
      this.fromMinDate = undefined;
      this.fromMaxDate = undefined;
      this.fromDefaultDate = undefined;
      this.fromSetDate = undefined;
      (<FormControl>this.additionalEducationSubForm.controls['jobFrom']).patchValue("");
    }
  }
  
  private setToDate() {
    if (this.dateOptions['to']) {
      this.toMinDate = this.toDateOptions['minDate'];
      this.toMaxDate = this.toDateOptions['maxDate'];
      this.toDefaultDate = this.toDateOptions['defaultDate'];
      this.toSetDate = this.toDateOptions['setDate'];
      
      let setMonthNo = new Date(this.toSetDate).getMonth();
      let setyear = new Date(this.toSetDate).getFullYear();
      let setMonthName = this.monthNames[setMonthNo];
      let setMonthYear = `${setMonthName} ${setyear}`;
      
      if (this.isEmploymentGapInDaysEnabled) {
        let setDay = new Date(this.toSetDate).getDate();
        let setMonthDayYear = `${setMonthName} ${setDay},${setyear}`;
        
        this.getToDpValue(setMonthDayYear);
      } else {
        this.getToDpValue(setMonthYear);
      }
    } else {
      if (this.additionalEducationSubForm.controls['jobTo'] !== undefined) {
        this.toMinDate = undefined;
        this.toMaxDate = undefined;
        this.toDefaultDate = undefined;
        this.toSetDate = undefined;
        (<FormControl>this.additionalEducationSubForm.controls['jobTo']).patchValue("");
      }
    }
  }
  
  /* Address Details - State methods - Start */
  
  trackStateChange(value) {
    let selectedData = !!value ? value : '';
    this.validateState(selectedData['state_name']);
    this.setZipStateCityFieldValues(selectedData);
    let type = 'city';
    this.clearFieldValues(type);
    this.selectedCity = '';
    this.cityList=[];
    this.cityTypeahead.emit('');
  }
  
  private stateServerSideSearch() {
    this.stateTypeahead.pipe(
      distinctUntilChanged(),
      filter(term => {  return (term !== undefined && term !== null) }),
      switchMap(term => this._sharedService.stateLookupSwitch({ 'countryCode': this.countryShortName, 'stateParam': term })
      .pipe(
        catchError(() => of({ 'state-data-list': [] }))
        )
      )
    ).subscribe(stateData => {
      this.stateList = stateData['state-data-list'];
    }, (err) => {
      console.log(err);
      this.stateList = [];
    });
  }
  
  onClearStateData() {
    (<FormControl>this.additionalEducationSubForm.controls['stateName']).setValue('');
    (<FormControl>this.additionalEducationSubForm.controls['stateCode']).setValue('');
    this.stateCode = this.stateShortName = '';
    this.stateLookUp('', null);
  }
  
  private validateState(value) {
    if (value !== undefined && value != '' && value !== null) {
      this.validStateFlag = true;
    } else {
      this.validStateFlag = false;
    }
  }
  
  stateLookUp(data, event) {
    let stateNameValue = (<FormControl>this.additionalEducationSubForm.controls['stateName']).value;
    
    if (!stateNameValue || stateNameValue === '') {
      let queryParam = {
        'countryCode': this.countryShortName,
        'stateParam': data.trim()
      };
      // call shared service to get state datas
      this._sharedService.stateLookupSwitch(queryParam).subscribe(response => {
        let stateData = response;
        // console.log('state Data: ' + JSON.stringify(stateData));
        this.stateList = stateData['state-data-list'];
        if (this.stateList.length > 0) {
          this.isStateListToShow = true;
        } else {
          this.isStateListToShow = false;
        }
      }, error => {
      });
    }
  }
  
  clearFieldValues(type) {
    if (type === 'city') {
      (<FormControl>this.additionalEducationSubForm.controls['city']).setValue('');
    } else if (type === 'cityState') {
      (<FormControl>this.additionalEducationSubForm.controls['city']).setValue('');
      (<FormControl>this.additionalEducationSubForm.controls['stateName']).setValue('');
      this.stateCode = this.stateShortName = '';
    }
  }
  
  openShowStateErr() {
    this.showStateErr = false;
  }
  
  closeStateError() {
    this.showStateErr = true;
  }
  
  /* Address Details - State methods - End */
  
  /* Address Details - Zip code methods - Start */
    
  trackZipCodeChange(value) {
    let selectedData = !!value ? value : '';
    this.setZipStateCityFieldValues(selectedData);
  }
  
  setZipValue(zip) {
    (<FormControl>this.additionalEducationSubForm.controls['zipCode']).setValue(zip);
  }
  
  setZipStateCityFieldValues(values): void {
    if (values['zip_code'] !== '' && values['zip_code'] !== undefined) {
      (<FormControl>this.additionalEducationSubForm.controls['zipCode']).setValue(values['zip_code']);
      (<FormControl>this.additionalEducationSubForm.controls['zipCode']).setErrors(null);
      this.zipCodeError = false;
    }
    
    if (values['city'] !== '' && values['city'] !== undefined) {
      (<FormControl>this.additionalEducationSubForm.controls['city']).setValue(values['city']);
    }

    if (values['state_code']) {
      (<FormControl>this.additionalEducationSubForm.controls['stateName']).setValue(values['state_name']);
      (<FormControl>this.additionalEducationSubForm.controls['stateCode']).setValue(values['state_code']);
      
      this.stateCode = this.stateShortName = values['state_code'];
    }
  }
  
  private zipCodeServerSideSearch() {
    this.zipCodeTypeahead.pipe(
      distinctUntilChanged(),
      filter(term => {  return (term !== undefined && term !== null) }),
      tap(term => this.setZipValue(term)),
      switchMap(term => this._sharedService.zipLookupSwitch(
        { 'countryCode': this.countryShortName, 'zipParam': !!term ? term : '',
          'stateCode': (this.additionalEducationSubForm.value.stateCode !== '') ? this.stateCode : '',
          'placeCode': (this.additionalEducationSubForm.value.city !== '') ? this.cityCode : ''
        })
      .pipe(
        catchError(() => of({ 'zipcode-data-list': [] }))
        )
      )
    ).subscribe(zipData => {
      this.zipCodeList = zipData['zipcode-data-list'];
    }, (err) => {
      console.log(err);
      this.zipCodeList = [];
    });
  }
  
  onClearZipCodeData() {
    (<FormControl>this.additionalEducationSubForm.controls['zipCode']).setValue('');
    this.zipCodeList = [];
  }
  
  openServerError() {
    this.zipCodeError = true;
  }

  closeServerError() {
    this.zipCodeError = false;
    (<FormControl>this.additionalEducationSubForm.controls['zipCode']).setErrors(null);
    // Call makeServerValidator in parent with flag false for zipcode
    this.onMakeServerValidator.emit({ control: 'zipCode', flag: false });
  }
  
  /* Address Details - Zip code methods - End */
  
  /* Address Details - City methods - Start */
    
  trackCityChange(value) {
    // console.log("city trackCityChange----");
    let selectedData = !!value ? value : '';
    this.validateCity(selectedData['city']);
    this.setZipStateCityFieldValues(selectedData);
  }
    
  private cityServerSideSearch() {
    this.cityTypeahead.pipe(
      distinctUntilChanged(),
      filter(term => {  return (term !== undefined && term !== null) }),
      tap(term => this.setCityValue(term)),
      switchMap(term => this._sharedService.cityLookupSwitch({ 'countryCode': this.countryShortName, 'stateCode': (!!this.additionalEducationSubForm.value.stateCode) ? this.additionalEducationSubForm.value.stateCode : '', 'cityParam': term })
      .pipe(
        catchError(() => of({ 'city-data-list': [] }))
        )
      )
    ).subscribe(cityData => {
      this.cityList = cityData['city-data-list'];
    }, (err) => {
      console.log(err);
      this.cityList = [];
    });
  }
    
  setCityValue(city) {
    (<FormControl>this.additionalEducationSubForm.controls['city']).setValue(city);
  }
  
  onClearCityData() {
    (<FormControl>this.additionalEducationSubForm.controls['city']).setValue('');
    this.cityLookUp('');
    this.cityTypeahead.emit('');
  }
    
  private validateCity(value) {
    if (value !== undefined && value != '' && value !== null) {
      this.validCityFlag = true;
    } else {
      this.validCityFlag = false;
    }
  }
    
  cityLookUp(data) {
    if (data.length > 0) {
      let queryParam = {
        'countryCode': this.countryShortName,
        'stateCode': (!!this.additionalEducationSubForm.value.stateCode) ? this.additionalEducationSubForm.value.stateCode : '',
        'cityParam': data.trim()
      };

      // call shared service to get city datas
      this._sharedService.cityLookupSwitch(queryParam).subscribe(response => {
        let cityData = response;
        this.cityList = cityData['city-data-list'];
        if (this.cityList.length > 0) {
          this.isCityListToShow = true;
        } else {
          this.isCityListToShow = false;
        }
      }, error => {
      });
    }
  }
    
  openShowCityErr() {
    this.showCityErr = false;
  }

  closeCityError() {
    this.showCityErr = true;
  }
    
  isEnableNextButton() {
    let isEnableNextButton = false;
    
    if (!this.additionalEducationSubForm.controls['jobFrom'].valid || !this.additionalEducationSubForm.controls['jobTo'].valid || this.invalidDate || !this.additionalEducationSubForm.controls['countryName'].valid || !this.additionalEducationSubForm.controls['stateName'].valid || !this.additionalEducationSubForm.controls['city'].valid || !this.additionalEducationSubForm.controls['zipCode'].valid) {
      isEnableNextButton = false;
    } else {
      isEnableNextButton = true;
    }
    
    return isEnableNextButton;
  }
  
  /* Address Details - City methods - Start */
  
  saveExit() {
    this.onSaveExit.emit();
  }
  
  openAdditionalEducationError() {
    this.isAdditionalEducationError = !this.isAdditionalEducationError;
  }
  
  closeAdditionalEducationError() {
    this.isAdditionalEducationError = !this.isAdditionalEducationError;
  }
  
  closeStartDateRangeErrorMsg() {
    this.showStartDateRangeErrorMsg = false;
  }
  
  closeEndDateRangeErrorMsg() {
    this.showEndDateRangeErrorMsg = false;
  }
}
